import * as actions from '@actions'
import { MAIN_TAB, TAB_TYPE_DEED, TAB_TYPE_LEASE } from '@/constants'
import { useMemo } from 'react'
import { MdAccountTree } from 'react-icons/md'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useWireValue } from '@forminator/react-wire'
import * as store from '@/store'

const ChainerLink = ({ runsheetId, currentTab, runsheetDocs }) => {
    
    const navigate = useNavigate()
    
    const remoteConfig = useWireValue(store.remoteConfig)
    
    // if important data is missing, then inform the user through a tooltip
    const missingForChainer = useMemo(() => runsheetDocs.some(r =>
        !r.value.instrumentDate || !r.value.grantors.length || !r.value.grantees.length)
    , [runsheetDocs])
    
    const isCategorizationEnabled = useMemo(() => remoteConfig.chainer?.leaseCategorizationEnabled, [remoteConfig])
    
    const navigateToChain = type => () => {
        
        // TODO: if called on main tab check if the runsheet has already been categorized and if there's already tabs. 
        // Should ask the user if they want to proceed to chaining on main tab anyway.
        // But only if the chain doesn't exist yet for that main tab. Either Deed or Lease.
        
        if (remoteConfig.chainer?.validateMissingData && missingForChainer) {
            const runsheetOrTabId = currentTab.id === MAIN_TAB ? runsheetId : currentTab.id
            
            actions.addFailedChainTry(runsheetOrTabId)
            return toast.warn('There\'s missing data from documents in this runsheet. The chainer can\'t proceed.')
        }
        
        navigate(`/runsheet/${runsheetId}/${type}?activeTab=${currentTab.id}`)
        
    }
    
    if (!isCategorizationEnabled) {
        return (
            <button
                onClick={navigateToChain('title-breakdown')}
                disabled={!runsheetDocs.length}
                data-tooltip-id="default-tip"
                data-tooltip-content={missingForChainer
                    ? `Missing Parties or
                Instrument Date might affect the outcome of the Title Chain`
                    : ''}>
                <MdAccountTree /><span className="ribbon-menu-text">Chain Title</span>
            </button>
        )
    }
    else if (currentTab.id === MAIN_TAB)
        return (
            <div>
                <div className="dropdown">
                    <button className="dropdown-button" data-tooltip-id="default-tip"
                        disabled={!runsheetDocs.length}
                        data-tooltip-content={missingForChainer
                            ? `Missing Parties or
                            Instrument Date might affect the outcome of the Title Chain`
                            : ''}>
                        <MdAccountTree /><span className="ribbon-menu-text">Chain Documents</span>
                    </button>
                    <ul className="dropdown-content menu shadow
                        bg-base-200 rounded-md w-44 max-xl:top-[32px] top-[80px] left-[-24px] m-0">
                        <li>
                            <button onClick={navigateToChain('title-breakdown')}>
                                <span className="ribbon-menu-text">Chain Title</span>
                            </button>
                        </li>
                        <li>
                            <button onClick={navigateToChain('lease-chain')}>
                                <span className="ribbon-menu-text">Chain Leasehold</span>
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        ) 
    else if (currentTab.type === TAB_TYPE_DEED)
        return (
            <button
                onClick={navigateToChain('title-breakdown')}
                disabled={!runsheetDocs.length}
                data-tooltip-id="default-tip"
                data-tooltip-content={missingForChainer
                    ? `Missing Parties or
                    Instrument Date might affect the outcome of the Title Chain`
                    : ''}>
                <MdAccountTree /><span className="ribbon-menu-text">Chain Title</span>
            </button>
        )
    else if (currentTab.type === TAB_TYPE_LEASE)
        return (
            <button
                onClick={navigateToChain('leasehold-chain')}
                disabled={!runsheetDocs.length}
                data-tooltip-id="default-tip"
                data-tooltip-content={missingForChainer
                    ? `Missing Parties or
                    Instrument Date might affect the outcome of the Lease Chain`
                    : ''}>
                <MdAccountTree /><span className="ribbon-menu-text">Chain Leasehold</span>
            </button>
        )
}

export default ChainerLink